import { partyMasterConfig } from './partyMaster';

/**
 * Seller master (redesigned 2026-10-16, migration 034; sign changed 2026-10-17, migration 037). A balance in a currency is NEGATIVE (red) when you owe the seller: a purchase
 * creates the dues and a payment settles them. A positive one means the seller owes you.
 * The seller shows in the invoice, purchase and payment dropdowns only for the currencies on its list, and only while it is Active.
 */
export const sellersConfig = partyMasterConfig({
  title: 'Sellers', singular: 'seller', icon: 'person-check', menu: 'purchasers', endpoint: '/purchasers',
  balances: 'purchasers', idKey: 'purchaserId', lookup: 'purchasers', balanceHeader: 'Outstanding balance',
  directions: [{ value: 'due', label: 'Seller owes you' }, { value: 'owe', label: 'You owe the seller' }],
  tips: ['Seller owes you', 'You owe the seller'],
  totalsTitle: 'Seller balances (active), by currency',
  note: 'Balance in a currency: red (negative) means you owe the seller, for example after a purchase that is not paid yet. A positive balance means the seller owes you.',
  currenciesHelp: 'The seller shows in dropdowns only for these currencies',
  activeHelp: 'Inactive sellers are hidden from dropdowns',
  locationHelp: 'For example Dubai, Deira',
});
